<div class="no-scroll patient-ob">

    <div class="wrapper">

        <!-- ========================== header (start) ========================== -->
        <header class="l-header">

            <div class="on-mobile header-logo">
                <img src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
            </div>
            <div class="l-header-panel">

               


                <nav class="header-menu">
                    
                    <span style="font-size: 22pt;font-weight: bold;">Clinic: {{loginService.Clinic ? loginService.Clinic : ''}}</span>
                    <a routerLink="/patsearch" class="header-menu-link icon-confirm" matTooltip="Exit Stats"></a>
                  

                </nav>

                <nav class="on-mobile header-mobilePanel">
                    <button class="btn-mobileMenu" id="open-headerMenu" data-show=".header-menu"
                        aria-label="open mobile menu"></button>
                    <button class="btn-mobileMenu" id="open-mainNav" data-show=".l-sidebar"
                        aria-label="open mobile sidebar"></button>
                </nav>

            </div>

        </header>
        <!-- ========================== header (end) ========================== -->


        <!-- ========================== intro (start) ========================== -->

        <main class="l-deashboard" style="padding-top: 0;" >

            <div class="h100 l-flex l-flex-w">

                <!-- history (start) -->
                <div class="w100 patient-ob-box" style="padding-bottom: 0;">
                    <div class="h100 m-box">
                        <h2>Natural Language Data Miner</h2>

                        <div class="w100 h100 l-flex-w">
                         Describe what you want to find in the text box below.
                        <textarea class="w100 h100 l-fg1" placeholder="Find me a corelation between EFW percentile and CNS organ warning markers"
                            [(ngModel)]="userRequest" style="height: 100px"
                            [readOnly]="aiHistory && aiHistory.length > 0"
                            [class.readonly-input]="aiHistory && aiHistory.length > 0"></textarea>
                        <select [(ngModel)]="AImodel" class="ai-model-select" *ngIf="!aiHistory || aiHistory.length === 0" style="align-self: flex-start;">
                                <option value="claude-opus-5">Claude Opus 5</option>
                                <option value="claude-sonnet-5">Claude Sonnet 5</option>
                                <option value="claude-haiku-4-5">Claude Haiku 4.5</option>
                                <option value="gpt-5.5">GPT 5.5</option>
                                <option value="gpt-5.4">GPT 5.4</option>
                                <option value="gpt-5.4-mini">GPT 5.4 mini</option>
                                <option value="gpt-5.4-nano">GPT 5.4 nano</option>
                                <option value="gemini-3.5-flash">Gemini 3.5 Flash</option>
                                <option value="gemini-3.1-pro-preview">Gemini 3.1 Pro Preview</option>
                                <option value="gemini-3-flash-preview">Gemini 3 Flash Preview</option>
                                <option value="gemini-3.1-flash-lite">Gemini 3.1 Flash-Lite</option>
                        </select>
                        <div *ngIf="loginService.isArtisanSupport && (!aiHistory || aiHistory.length === 0)" style="vertical-align: top;">
                            <input type="checkbox" [(ngModel)]="runGlobally"/> Run search across all clinics
                        </div>
                        <div *ngIf="(aiHistory && aiHistory.length > 0) || !showButton" class="search-params-info">
                            Model: <b>{{AImodelNames[AImodel] || AImodel}}</b>
                            <span *ngIf="loginService.isArtisanSupport && runGlobally">&nbsp;|&nbsp;All clinics</span>
                        </div>
                        <button class="search-btn" (click)="sendAI()" matTooltip="Send to AI to build DB query" *ngIf="showButton && (!aiHistory || aiHistory.length === 0)">Search</button>

                        <!-- Collapsible AI history -->
                        <div class="ai-history-controls" *ngIf="aiHistory && aiHistory.length > 0" style="margin: 10px 0; vertical-align: top;">
                            <button (click)="resetHistory()" style="float:right;">Reset History</button>
                            <button (click)="showLog = !showLog" class="log-toggle-btn">{{ showLog ? 'Hide Log' : 'Show Log' }} ({{logEntries.length}})</button>
                        </div>
                        <div *ngIf="aiHistory && aiHistory.length" style="min-width: 0; width: 100%;">
                            <div *ngFor="let entry of aiHistory; let i = index">
                                <div class="ai-history-entry">
                                    <button (click)="entry.expanded = !entry.expanded" class="ai-history-toggle">
                                        {{ entry.expanded ? '▼' : '►' }}
                                        <span style="font-weight:bold">Query #{{i + 1}}</span>
                                    </button>
                                    <div *ngIf="entry.expanded" class="ai-history-details">
                                        <div *ngIf="entry.query"><b>query:</b> {{entry.query}}</div>
                                        <div *ngIf="entry.explanation"><b>explanation:</b> {{entry.explanation}}</div>
                                        <div *ngIf="entry.notes"><b>Notes (clarification - non data response):</b> {{entry.notes}}</div>
                                        <div *ngIf="entry.status"><b> {{entry.status}}</b></div>
                                        <div *ngIf="entry.results && entry.results.length">
                                            <div class="ai-results-toolbar">
                                                <div>
                                                    Showing {{getShownRowCount(entry)}}
                                                    <span *ngIf="entry.totalRowCount > getShownRowCount(entry)">of {{entry.totalRowCount}}</span>
                                                    rows.
                                                </div>
                                                <button *ngIf="hasDownloadData(entry)" class="search-btn ai-download-btn" (click)="downloadResults(entry)">
                                                    Download Excel
                                                </button>
                                            </div>
                                            <div *ngFor="let recordset of entry.results">
                                                <div class="ai-results-wrapper">
                                                <table class="ai-results-table">
                                                    <thead>
                                                        <tr>
                                                            <th *ngFor="let key of getResultKeys(recordset, entry)">{{ getColumnLabel(key) }}</th>
                                                            <th *ngIf="showActionColumn(entry)">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let row of recordset">
                                                            <td *ngFor="let key of getResultKeys(recordset, entry)" [innerHTML]="sanitizeHtml(formatCellValue(row[key]))" [title]="formatCellValue(row[key])"></td>
                                                            <td *ngIf="showActionColumn(entry)">
                                                                <button class="ai-row-link" type="button" (click)="openRow(entry, row)">{{getActionLabel(entry)}}</button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="!entry.results || entry.results.length == 0">
                                            Query returned no results.
                                        </div>
                                        <div *ngIf="entry.userResponse">
                                            <b>Your response:</b> {{entry.userResponse}}
                                        </div>
                                        <div *ngIf="!entry.userResponse && showButton">
                                            <textarea class="w100 h100 l-fg1" [(ngModel)]="entry.tempUserResponse" placeholder="Respond to this result..." style="width:100%;margin-top:8px;"></textarea>
                                            <button (click)="saveUserResponse(entry)" class="search-btn">Respond</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- LLM interaction log panel -->
                        <div *ngIf="showLog && logEntries.length > 0" class="log-panel">
                            <h3 class="log-panel-title">LLM Interaction Log</h3>
                            <div *ngFor="let entry of logEntries; let i = index" class="log-entry">
                                <div class="log-entry-header">
                                    <span class="log-entry-num">#{{i + 1}}</span>
                                    <span class="log-entry-time">{{entry.timestamp | date:'HH:mm:ss'}}</span>
                                    <span class="log-entry-model">{{AImodelNames[entry.model] || entry.model}}</span>
                                    <span *ngIf="entry.isFollowup" class="log-entry-tag">follow-up</span>
                                </div>
                                <div class="log-field">
                                    <span class="log-label">User input:</span>
                                    <pre class="log-pre">{{entry.question}}</pre>
                                </div>

                                <!-- Server → LLM calls (from server llmLog) -->
                                <div *ngIf="entry.rawResponse?.llmLog?.length" class="log-field">
                                    <span class="log-label">Server → LLM calls ({{entry.rawResponse.llmLog.length}}):</span>
                                    <div *ngFor="let call of entry.rawResponse.llmLog; let j = index" class="log-sub-entry">
                                        <div class="log-sub-type">{{j + 1}}. <b>{{call.label}}</b> &mdash; {{call.model}}</div>
                                        <div class="log-field">
                                            <span class="log-label">Prompt sent to LLM:</span>
                                            <pre class="log-pre">{{prettyJsonOrString(call.prompt)}}</pre>
                                        </div>
                                        <div class="log-field">
                                            <span class="log-label">Raw LLM response:</span>
                                            <pre class="log-pre">{{call.rawResponse}}</pre>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="!entry.rawResponse?.llmLog?.length" class="log-field log-note">
                                    No LLM call log available — update the server to the latest version.
                                </div>

                                <!-- API response summary (without llmLog to avoid duplication) -->
                                <div class="log-field">
                                    <span class="log-label">API response:</span>
                                    <pre class="log-pre">{{prettyJsonWithoutLlmLog(entry.rawResponse)}}</pre>
                                </div>

                                <!-- Embedded repair / clarification step logs -->
                                <div *ngIf="entry.rawResponse?.logs?.length" class="log-field">
                                    <span class="log-label">Repair / clarification steps ({{entry.rawResponse.logs.length}}):</span>
                                    <div *ngFor="let lg of entry.rawResponse.logs" class="log-sub-entry">
                                        <div *ngIf="lg.type" class="log-sub-type">Step: {{lg.type}}</div>
                                        <div *ngIf="lg.attempt" class="log-sub-type">Repair attempt {{lg.attempt}}</div>
                                        <div *ngIf="lg.error" class="log-field"><span class="log-label">Error:</span><pre class="log-pre log-error">{{lg.error}}</pre></div>
                                        <div class="log-field"><span class="log-label">LLM parsed response:</span><pre class="log-pre">{{prettyJson(lg.response)}}</pre></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spinner and error at the bottom, below all history -->
                        <img src="assets/icons/spinning-wheel.svg" alt="Loading..." *ngIf="!showButton" style="width: 10em;"/>
                        <div *ngIf="AIError" style="color:brown">{{AIError}}</div>
                    </div>
                </div>
            </div>
                <!-- history (end) -->

                <!-- new exam (start) -->
                
                  
                </div>
            

           
        </main>

        <!-- ========================== main sidebar (start) ========================== -->

        <aside class="l-sidebar l-flex l-column">

            <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

            <!-- user panel (start) -->

            <!-- user panel (end) -->

            <!-- main nav (start) -->
            <nav class="mainNav l-fg1 scroller">

            </nav>
            <!-- main nav (end) -->

            <app-docpanel></app-docpanel>

        </aside>

        <!-- ========================== main sidebar (end) ========================== -->

        <app-bottombar></app-bottombar>

    </div><!-- end wrapper -->
</div>